export default "__VITE_ASSET__DwNlGEkj__"